// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import ElementUI from 'element-ui'
import api from './api' // 导入api接口
import moment from 'moment';
import has from '@/api/directive.js';
import {ajax, interceptors, setOpt} from '@/components/mc-ui'
import selectMap from '@/common/select-map.js'
import 'babel-polyfill'
Vue.prototype.$selectMap = selectMap;
Vue.prototype.$moment = moment;
Vue.prototype.$ajax = ajax;


import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/fonts/iconfont.css'
import '@/assets/css/style.css'
import '@/assets/scss/elebase.scss'
import '@/assets/scss/style.scss'
import '@/assets/scss/common.scss'

import router from './router'

import onlyNumber from '@/directive/el-input';
import * as Utils from '@/common/common'
Object.defineProperty(Vue.prototype, '$Utils', {value: Utils})

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$api = api; // 将api挂载到vue的原型上
Vue.use(onlyNumber);
// 拦截路由文件
import './api/premission'

// vuex
import store from './store/index'

Vue.component('footer-copyright', {
  template: '<p class="footer-msg">©CopyRight 2019-2022 步步高 版权所有 <a href="http://www.bbg.com.cn/" target="_blank">湘ICP备******号</a></p>'
});

Vue.filter('formatDateTime', function (value) {
  if (!value) return ''
  let date = new Date(value);
  let y = date.getFullYear() + '/';
  let mon = (date.getMonth() + 1) + '/';
  let d = date.getDate();
  return y + mon + d;
});
Vue.filter('dateformat', function(dataStr, pattern) {
  if(dataStr==''){
    return dataStr;
  }else{
    return moment(dataStr).format(pattern || 'YYYY-MM-DD HH:mm:ss')
  }
});
// 全局挂载跳转方法 把参数存到sessionStorage里面
Vue.prototype.$jumpto = function(url, paramname, param , target) {
    let oldParam = {},
		newParam = {};
		if(sessionStorage.getItem(paramname)){
				oldParam = JSON.parse(sessionStorage.getItem(paramname));
				// Object.keys(params).forEach(item=>{
				//     if(oldParam[item]) oldParam[item] = newParam[item];
				// })
				newParam = {
						...oldParam,
						...param
				}
		}else{
			newParam = {
				...param
			}
		}
	sessionStorage.setItem(paramname, JSON.stringify(newParam));
	const newUrl = this.$router.resolve({ path: url, query: param });

	if(target){
		window.open(newUrl.href,'_blank')
	}else{
		router.push({ path: url, query: param });
	}

}

Vue.prototype.$getUserId = function(){
	var userInfo = sessionStorage.userInfo;
	userInfo = JSON.parse(userInfo);
	return userInfo.id;
}

Vue.prototype.$getUserName = function(){
	var userInfo = sessionStorage.userInfo;
	userInfo = JSON.parse(userInfo);
	return userInfo.name;
}

// 请求统一处理 begin
interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.resolve(false)
  }
)

let error = new Vue().$message.error
interceptors.response.use(
  response => {
    // code码说明
    // '0000': 成功, '9999','0007','0008','400': 业务异常, '500': 系统异常
    // 避免取对象报错
    if (response.data.result === null) {
      response.data.result = false
    }
    let code = Number(response.data.code)
    if ((!response.data || code === undefined) && response.data.indexOf('DOCTYPE html') < 0) {
      error('接口格式错误')
      return Promise.resolve(false)
    } else if (response.data) {
      if (code === 401) {
        router.replace({path: '/login', query: {redirect: router.currentRoute.fullPath}});
        return Promise.resolve(false)
      } else if (code === 403) {
        error('登录过期，请重新登录');
        localStorage.removeItem('token');
        store.commit('loginSuccess', null);
        setTimeout(() => {
          router.replace({path: '/login', query: {redirect: router.currentRoute.fullPath}});
        }, 1000);
      }
      else if (Number(code) !== 0) {
        /* if (response.data.msg && response.data.msg.length !== 0) {
          error(response.data.msg)
          return Promise.resolve(false)
        } */
      }
    }
    return Promise.resolve(response)
  },
  err => {
    if (err.message.includes('timeout')) {
      error('请求超时')
    } else {
      error('接口错误')
    }
    Promise.resolve(false)
  }
)

setOpt({
  withCredentials: true,
  timeout: 1000 * 30,
  baseURL: window.IPConfig.HOST ? (window.IPConfig.IP + ':' + window.IPConfig.HOST) : window.IPConfig.IP
})
// 请求统一处理 end

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js